// extracted by mini-css-extract-plugin
export var card = "profile-module--card--5419e";
export var stack = "profile-module--stack--9df01";